import React, { forwardRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../../Images/LogoT1.png";
import sign from "../../assets/signn.png";
const PackingListTemplate = forwardRef(({ invoiceData, invoiceDate, onEdit }, ref) => {
  const totalWeight = invoiceData?.users?.reduce(
    (sum, item) => sum + Number(item.netWeight || 0),
    0,
  );
  const totalGROSS = invoiceData?.users?.reduce(
    (sum, item) => sum + Number(item.grossWeight || 0),
    0,
  );

  const totalProducts = invoiceData?.users?.length;

  const downloadPDF = async () => {
    const input = document.getElementById("pdf-content");

    const canvas = await html2canvas(input, {
      scale: 4,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();

    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save(`${invoiceData?.purchaser} ${invoiceData.invoiceType === "COMMERCIAL_INVOICE" ? "CASH INVOICE" : invoiceData.invoiceType === "TAX_INVOICE" ? "TAX INVOICE" : "PACKING LIST"}.pdf`);
  };

  const totalAmount = invoiceData?.users.reduce((acc, record) => {
    return acc + record.quantity * record.price;
  }, 0);

  let discountAmmount = parseFloat(
    (totalAmount * (invoiceData?.discount / 100))?.toFixed(2),
  );
  let igstAmmount = parseFloat(
    (totalAmount * (invoiceData?.igst / 100))?.toFixed(2),
  );
  let cgstAmmount = parseFloat(
    (totalAmount * (invoiceData?.cgst / 100))?.toFixed(2),
  );
  let sgstAmmount = parseFloat(
    (totalAmount * (invoiceData?.sgst / 100))?.toFixed(2),
  );
  let totalTax = parseFloat(
    (igstAmmount + cgstAmmount + sgstAmmount)?.toFixed(2),
  );
  const invoiceTableColumns = [
    {
      span: "col-span-1",
      text: "SR No.",
      render: (text, record, index) => index + 1,
    },
    {
      span: "col-span-1",
      text: "HSN Code",
    },
    {
      span: "col-span-4",
      text: "Product Name",
    },
    {
      span: "col-span-2",
      text: "Product QTY",
      render: (text, record) => (
        <span>
          {record.quantity} &nbsp;
          {record.quantityUnit}
        </span>
      ),
    },
    {
      span: "col-span-2",
      text: "Price",
    },
    {
      span: "col-span-2",
      text: "Amount",
      title: "Amount",
      render: (text, record) => <span>{record.price * record.quantity}</span>,
    },
  ];
  const packingTableColumns = [
        {
      span: "col-span-1",
      text: "SR No.",
      render: (text, record, index) => index + 1,
    },
    {
      span: "col-span-1",
      text: "Product Code",
    },
    {
      span: "col-span-4",
      text: "Description of Goods",
    },
    {
      span: "col-span-2",
      text: "Unit Quantity",
    },
    {
      span: "col-span-2",
      text: "Net Weight (Kg)",
    },
    {
      span: "col-span-2",
      text: "Gross Weight",
    },
  ];
  const isPackingList = invoiceData?.invoiceType === "PACKING_LIST";
  const documentColumn = isPackingList
    ? packingTableColumns
    : invoiceTableColumns;

    console.log("invoiceData", invoiceData)

  return (
    <>
      <div
        id="pdf-content"
        ref={ref}
        className="relative mx-auto text-black overflow-hidden"
        style={{
          width: "210mm",
          minHeight: "297mm",
          padding: ".10mm",
          boxSizing: "border-box",
          fontFamily: "Arial",
          fontSize: "12px",
          background: "#fff",
        }}
      >
        {/* WATERMARK */}

        <div
          className="absolute inset-0 flex items-center justify-center pointer-events-none"
          style={{
            opacity: 0.12,
            zIndex: 0,
          }}
        >
          <img
            src={logo}
            alt="watermark"
            className="w-[800px] object-contain"
          />
        </div>

        {/* TITLE */}

        <div className="text-center pb-2 relative z-10 bg-[#275A7D]">
          <h1 className="text-[20px] font-bold text-[#D3AF37]">{invoiceData.invoiceType === "COMMERCIAL_INVOICE" ? "CASH INVOICE" : invoiceData.invoiceType === "TAX_INVOICE" ? "TAX INVOICE" : "PACKING LIST"}</h1>
        </div>

        {/* MAIN BORDER */}

        <div
          className="relative z-10"
          style={{
            border: "4px solid #D3AF37",
            minHeight: "282mm",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {/* TOP SECTION */}

          <div>
            <div
              className="grid grid-cols-12"
              style={{
                borderBottom: "1.5px solid black",
                backgroundColor: "#e6f4ff",
              }}
            >
              {/* EXPORTER */}

              <div
                className="col-span-6"
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <div className="p-1 leading-5">
                  <p>Consignor</p>

                  <p className="font-bold">TANDA RUBBER WORKS</p>

                  <p className="font-bold">
                    0, NEHRU NAGAR TANDA, AMBEDKAR NAGAR, UTTAR PRADESH, 224190
                  </p>

                  <p>India</p>

                  <p>+916394750886</p>

                  <p className="font-bold">SHAKEEL AHMAD</p>

                  <p className="font-bold">GSTIN: 09CXQPA7585K1ZN</p>

                  <p className="font-bold">IEC: CXQPA7585K</p>
                </div>
              </div>

              {/* LOGO */}

              <div
                className="col-span-3 flex items-center justify-center"
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <img
                  src={logo}
                  alt="logo"
                  className="w-[170px] object-contain"
                />
              </div>

              {/* RIGHT */}

              <div className="col-span-3">
                <div
                  className="flex justify-end p-1 h-[30px]"
                  style={{
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <div className="text-right">
                    <p className="font-bold">Pages : 1</p>
                  </div>
                </div>

                <div
                  className="h-[55px] flex flex-col justify-center items-center"
                  style={{
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <p>Export Invoice Date</p>

                  <p className="font-bold mt-1"> {invoiceDate}</p>
                </div>

                <div className="h-[55px] flex flex-col justify-center items-center">
                  <p>Invoice No</p>

                  <p className="font-bold">{invoiceData?.invoiceNo}</p>
                </div>
              </div>
            </div>

            {/* CONSIGNEE */}

            <div
              className="p-1"
              style={{
                height: "132px",
                borderBottom: "1.5px solid black",
              }}
            >
              <p>Consignee</p>

              <div className="font-bold leading-5 whitespace-pre-line">
                <p>{invoiceData?.purchaser}</p>
                <p>{invoiceData?.purchaser_company}</p>
                <p>GSTIN: {invoiceData?.purchaseGSTNr}</p>

                <p>{invoiceData?.purchaserAddress}</p>

                <p>
                  {invoiceData?.purchaserState},{invoiceData?.pinCode},
                  {invoiceData?.purchaserCountry}
                </p>

                <p>{invoiceData?.mobileNo}</p>
              </div>
            </div>

            {/* SHIPPING */}

            <div
              className="grid grid-cols-4"
              style={{
                borderBottom: "1.5px solid black",
              }}
            >
              {[
                {
                  title: "Method of Dispatch",
                  value: invoiceData?.DispatchMethod,
                },
                {
                  title: "Type of Shipment",
                  value: invoiceData?.Shipment,
                },
                {
                  title: "Country Of Origin Of Goods",
                  value: "India",
                },
                {
                  title: "Country Of Final Destination",
                  value: invoiceData?.distination,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="p-1"
                  style={{
                    borderRight: index !== 3 ? "1.5px solid black" : "none",
                  }}
                >
                  <p>{item.title}</p>

                  <p className="font-bold">{item.value}</p>
                </div>
              ))}
            </div>

            {/* PORTS */}

            <div
              className="grid grid-cols-4"
              style={{
                borderBottom: "1.5px solid black",
              }}
            >
              <div
                className="p-1"
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <p>Port of Loading</p>

                <p className="font-bold">{invoiceData?.loadingPort}</p>
              </div>

              <div
                style={{
                  borderRight: "1.5px solid black",
                }}
              ></div>

              <div className="col-span-2 p-1">
                <p>Packing Information</p>

                <p className="font-bold leading-5">
                  {invoiceData?.packing_information}
                </p>
              </div>
            </div>

            {/* DESTINATION */}

            <div
              className="grid grid-cols-4"
              style={{
                borderBottom: "1.5px solid black",
              }}
            >
              <div
                className="p-1"
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <p>Port of Discharge</p>

                <p className="font-bold">{invoiceData?.dISCHARGE_port}</p>
              </div>

              <div
                className="p-1"
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <p>Final Destination</p>

                <p className="font-bold">{invoiceData?.packing_information}</p>
              </div>
            </div>

            {/* TABLE HEADER */}

            <div
              className="grid grid-cols-12 text-center mt-1"
              style={{
                borderBottom: "1.5px solid black",
                 borderTop: "3px solid black",
              }}
            >
              {documentColumn?.map((item, index) => (
                <div
                  key={index}
                  className={`${item.span} p-1`}
                  style={{
                    borderRight: index !== 5 ? "1.5px solid black" : "none",
                  }}
                >
                  {item.text}
                </div>
              ))}
            </div>

            {/* GOODS */}

            {!isPackingList ? (
              <div
                style={{
                  minHeight: "300px",
                }}
              >
                {invoiceData.users.map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-12"
                    style={{
                      borderBottom: "1.5px solid black",
                      minHeight: "32px",
                    }}
                  >
                    <div
                      className="col-span-1 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {index + 1}
                    </div>

                    <div
                      className="col-span-1 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {item.hsnCode}
                    </div>

                    <div
                      className="col-span-4 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {item.description}
                    </div>

                    <div
                      className="col-span-2 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {item.quantity} {item.quantityUnit}
                    </div>

                    <div
                      className="col-span-2 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {item.price}
                    </div>
                    <div className="col-span-2 p-1 flex items-center justify-center text-center font-bold">
                      {item.price * item.quantity}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  minHeight: "300px",
                }}
              >
                {invoiceData.users.map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-12"
                    style={{
                      borderBottom: "1.5px solid black",
                      minHeight: "32px",
                    }}
                  >
                   <div
                      className="col-span-1 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {index + 1}
                    </div>

                    <div
                      className="col-span-1 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {item.hsnCode}
                    </div>

                    <div
                      className="col-span-4 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {item.description}
                    </div>

                    <div
                      className="col-span-2 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {item.quantityUnit}
                    </div>

                    <div
                      className="col-span-2 p-1 flex items-center justify-center text-center font-bold"
                      style={{
                        borderRight: "1.5px solid black",
                      }}
                    >
                      {item.netWeight}
                    </div>

                    <div className="col-span-2 p-1 flex items-center justify-center text-center font-bold">
                      {item.grossWeight}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* TOTAL */}
            {invoiceData.invoiceType === "PACKING_LIST" ? (
              <>
                {" "}
                <div
                  className="flex items-center justify-between px-10"
                  style={{
                    minHeight: "32px",
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <p>Total This Page</p>

                  <div className="flex gap-28 font-bold">
                    <p>{totalProducts}</p>
                    <p>{totalWeight}</p>
                    <p>{totalGROSS}</p>
                  </div>
                </div>
                {/* CONSIGNMENT */}
                <div
                  className="flex items-center justify-between px-10"
                  style={{
                    minHeight: "32px",
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <p>Consignment Total</p>

                  <div className="flex gap-28 font-bold">
                    <p>{totalProducts}</p>
                    <p>{totalWeight}</p>
                    <p>{totalGROSS}</p>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          {/* FOOTER */}
          {invoiceData.invoiceType === "PACKING_LIST" ? (
            <div
              className="grid grid-cols-2"
              style={{
                minHeight: "140px",
                backgroundColor: "#dbeafe",
              }}
            >
              {/* LEFT */}

              <div
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <p className="ml-1">Additional Info</p>

                <p className="font-bold mt-1 ml-1">
                  PORT OF DELIVERY :{invoiceData.delivery_port}
                </p>

                <div className="mt-4 p-1">
                  <p>Bank Information</p>

                  <p className="font-bold mt-1">Bank Name: HDFC Bank</p>

                  <p className="font-bold mt-1">
                    Account Name: TANDA RUBBER WORKS
                  </p>

                  <p className="font-bold mt-1">Account Number: 50200124728162</p>

                  <p className="font-bold mt-1">IFSC Code: HDFC0003941</p>
                </div>
              </div>

              {/* RIGHT */}

              <div
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <div
                  className="p-1"
                  style={{
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <p>Signatory Company</p>

                  <p className="font-bold"> TANDA RUBBER WORKS</p>
                </div>

                <div
                  className="p-1"
                  style={{
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <p>Name of Authorized Signatory</p>

                  <div className="font-bold">SHAKEEL AHMAD</div>
                </div>

                <div className="p-1">
                  <p>Signature</p>

                  <div className="flex items-center justify-center h-[67px]">
                    <img src={sign} className="w-full ml-3" />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="grid grid-cols-3"
              style={{
                minHeight: "140px",
                borderTop: "1.5px solid black",
                backgroundColor: "#dbeafe",
              }}
            >
              {/* LEFT */}

              <div
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <p className="ml-1">Additional Info</p>

                <p className="font-bold mt-1 ml-1">
                  PORT OF DELIVERY :{invoiceData.delivery_port}
                </p>

                <div className="mt-4 p-1">
                  <p>Bank Information</p>

                  <p className="font-bold mt-1">Bank Name: HDFC Bank</p>

                  <p className="font-bold mt-1">
                    Account Name: TANDA RUBBER WORKS
                  </p>

                  <p className="font-bold mt-1">Account Number: 50200124728162</p>

                  <p className="font-bold mt-1">IFSC Code: HDFC0003941</p>
                </div>
              </div>

              <div
                style={{
                  borderRight: "1.5px solid black",
                }}
              >
                <div
                  className="p-1"
                  style={{
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <p>Signatory Company</p>

                  <p className="font-bold"> TANDA RUBBER WORKS</p>
                </div>

                <div
                  className="p-1"
                  style={{
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <p>Name of Authorized Signatory</p>

                  <div className="font-bold">SHAKEEL AHMAD</div>
                </div>

                <div className="p-1">
                  <p>Signature</p>

                  <div className="flex items-center justify-center h-[67px]">
                    <img src={sign} className="w-full ml-3" />
                  </div>
                </div>
              </div>

              <div>
                <div
                  className="p-1"
                  style={{
                    borderBottom: "1.5px solid black",
                    display: "flex",
                    gap: "80px",
                  }}
                >
                  <p className="font-bold">TOTAL AMOUNT :</p>
                  <p className="font-bold">
                    {" "}
                    {new Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                    }).format(totalAmount)}
                  </p>
                </div>
                <div
                  className="p-1"
                  style={{
                    borderBottom: "1.5px solid black",
                    display: "flex",
                    gap: "75px",
                  }}
                >
                  <p className="font-bold">TOTAL DISCOUNT:</p>
                  <p className="font-bold">
                    {new Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                    }).format(discountAmmount)}
                  </p>
                </div>
                <div
                  className="p-1"
                  style={{
                    borderBottom: "1.5px solid black",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "115px",
                    }}
                  >
                    <p className="font-bold">TOTAL TAX:</p>
                    <p className="font-bold">
                      {" "}
                      {new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                      }).format(totalTax)}
                    </p>
                  </div>
                  <div className="flex gap-1">
                    <p>CGST:</p>
                    <p>
                      {new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                      }).format(sgstAmmount)}
                    </p>
                  </div>
                  <div className="flex gap-1">
                    <p>SGST:</p>
                    <p>
                      {" "}
                      {new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                      }).format(cgstAmmount)}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <p>IGST:</p>
                    <p>
                      {" "}
                      {new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                      }).format(igstAmmount)}
                    </p>
                  </div>
                </div>
                <div className="p-1">
                  <div
                   style={{paddingBottom: "6px",
                  }}
                  >
                    <p className="flex font-bold justify-center">GRAND TOTAL:</p>
                    <p className="flex font-extrabold text-lg justify-center">
                      {new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        Number(totalTax + totalAmount - discountAmmount),
                      )}
                    </p>
                  </div>
                
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* DOWNLOAD */}

      <div className="flex justify-center gap-3 mt-4">
        <button
          onClick={onEdit}
          className="bg-slate-600 text-white px-4 py-2 rounded"
          type="button"
        >
          Edit Invoice
        </button>
        <button
          onClick={downloadPDF}
          className="bg-black text-white px-4 py-2 rounded"
          type="button"
        >
          Download PDF
        </button>
      </div>
    </>
  );
});

export default PackingListTemplate;
